module.exports = __webpack_public_path__ + "static/img_1290-264f310acf4cbdfb6b67302bf8254d7b.webp";